import type { FormDefinition } from './types'

export default {
  sections: {
    Person: {
      fields: [{ id: 'Person.Geburtsdatum', control: 'date' }],
    },
    Kontakt: {
      fields: [
        { id: 'Kontakt.Telefon', control: 'text-or-date' },
        { id: 'Kontakt.Straße', control: 'text-or-date' },
        { id: 'Kontakt.Hausnummer', control: 'text-or-date' },
        { id: 'Kontakt.PLZ', control: 'text-or-date' },
        { id: 'Kontakt.Ort', control: 'text-or-date' },
      ],
    },
  },
} satisfies FormDefinition
